"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BaseDeserializationResult {
}
exports.BaseDeserializationResult = BaseDeserializationResult;
class OkDeserializationResult extends BaseDeserializationResult {
    constructor(value) {
        super();
        this.value = value;
    }
    get isOk() {
        return true;
    }
    unwrap() {
        return this.value;
    }
}
exports.OkDeserializationResult = OkDeserializationResult;
class ErrorDeserializationResult extends BaseDeserializationResult {
    constructor(errors) {
        super();
        this.errors = errors;
    }
    unwrap() {
        throw new Error("Cannot unwrap error. This indicates a bug.");
    }
    get isOk() {
        return false;
    }
}
exports.ErrorDeserializationResult = ErrorDeserializationResult;
function deserializationValue(value) {
    return new OkDeserializationResult(value);
}
exports.deserializationValue = deserializationValue;
function deserializationError(...errors) {
    return new ErrorDeserializationResult(errors.map(e => {
        if (e instanceof DeserializationError) {
            return e;
        }
        return new DeserializationError({ message: e.message });
    }));
}
exports.deserializationError = deserializationError;
class DeserializationError {
    constructor(error) {
        this.message = error.message;
        this.path = error.path === undefined ? [] : error.path;
    }
    prependPath(path) {
        return new DeserializationError({
            message: this.message,
            path: [path].concat(...this.path),
        });
    }
}
exports.DeserializationError = DeserializationError;
//# sourceMappingURL=result.js.map